import styled, { css } from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
import { injectTypography } from '../../utils/injectTypography';
import { cssPostfix } from '../../utils/cssPostfix';
export const listClassName = `list-${cssPostfix}`;
const dynamicSpacingLarge = (props) => {
    switch (props.textVariant) {
        case 'copy1':
            return `var(${props.theme.responsive.spacing.l})`;
        case 'copy2':
            return `var(${props.theme.responsive.spacing.m})`;
        case 'copy3':
            return `var(${props.theme.responsive.spacing.s})`;
        default:
            return `var(${props.theme.responsive.spacing.l})`;
    }
};
const dynamicSpacingMedium = (props) => {
    switch (props.textVariant) {
        case 'copy1':
            return `var(${props.theme.responsive.spacing.m})`;
        case 'copy2':
            return `var(${props.theme.responsive.spacing.s})`;
        case 'copy3':
            return `var(${props.theme.responsive.spacing.xs})`;
        default:
            return `var(${props.theme.responsive.spacing.m})`;
    }
};
const BaseListStyles = css `
  --list-padding-inline-start: var(
    --nested-list-padding-inline-start,
    calc(${dynamicSpacingLarge} * 2)
  );

  --list-item-padding-inline-end: ${dynamicSpacingMedium};

  --list-item-margin-block-start: var(
    --nested-item-margin-block-start,
    ${dynamicSpacingLarge}
  );

  --list-item-margin-block-end: var(
    --nested-item-margin-block-end,
    ${dynamicSpacingLarge}
  );

  margin: 0;

  padding-inline-start: var(--list-padding-inline-start);

  ${injectSpacing('margin')}

  ${(props) => injectTypography(props, props.textVariant)}

  counter-reset: section;

  .${listClassName} {
    --nested-list-padding-inline-start: ${dynamicSpacingLarge};
    --nested-item-margin-block-start: ${dynamicSpacingMedium};
    --nested-item-margin-block-end: ${dynamicSpacingMedium};
  }
`;
const BaseListItemStyles = css `
  position: relative;

  color: ${(props) => props.theme.colors.utility.neutral[80]};

  list-style: none;

  ${injectOSXFontSmoothing(true)}

  margin-block-end: var(--list-item-margin-block-end);
  margin-block-start: var(--list-item-margin-block-start);

  &:first-child {
    margin-block-start: 0;
  }

  &:last-child {
    margin-block-end: 0;
  }

  &::before {
    position: absolute;
    left: 0;
    padding-inline-end: var(--list-item-padding-inline-end);

    color: ${(props) => props.theme.colors.utility.neutral[80]};

    transform: translateX(-100%);

    content: var(--counter-content);
    counter-increment: section;
  }
`;
export const StyledListItem = styled.li `
  ${BaseListItemStyles}
`;
export const StyledListUnordered = styled.ul `
  ${BaseListStyles}

  ${StyledListItem} &:first-child {
    margin-block-start: var(--list-item-margin-block-start);
  }

  ${StyledListItem} &:last-child {
    margin-block-end: var(--list-item-margin-block-end);
  }

  --counter-content: '${(props) => (props.variant === 'bullet' ? '›' : '')}';
`;
export const StyledListOrdered = styled.ol `
  ${BaseListStyles}

  ${StyledListItem} &:first-child {
    margin-block-start: var(--list-item-margin-block-start);
  }

  ${StyledListItem} &:last-child {
    margin-block-end: var(--list-item-margin-block-end);
  }

  --counter-content: counters(section, '.', ${(props) => props.variant}) '.';
`;
//# sourceMappingURL=List.styles.js.map